import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Typography, Tabs, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Chip, IconButton } from '@mui/material';
import { Icon } from '@iconify/react';
import { useToast } from './ui/ToastProvider';
interface BulkUploadListsModalProps {
  open: boolean;
  onClose: () => void;
  batch: {
    fileId: string;
    batchId: string;
    fileName: string;
    dataRows: number;
  };
}
interface RecordData {
  id: number;
  fullName: string;
  username: string;
  email: string;
  mobile: string;
  currency: string;
  branchCode: string;
  settlementAccount: string;
  designation: string;
  status: 'valid' | 'invalid' | 'duplicate';
  errorReason?: string;
}
const MOCK_NEW_RECORDS: RecordData[] = [{
  id: 1,
  fullName: 'Ahmed Hassan',
  username: 'ahmed.hassan',
  email: 'ahmed.hassan@example.com',
  mobile: '+92 300 1234567',
  currency: 'PKR',
  branchCode: '0001',
  settlementAccount: 'ACC-10001',
  designation: 'Manager',
  status: 'valid'
}, {
  id: 2,
  fullName: 'Sara Khan',
  username: 'sara.khan',
  email: 'sara.khan@example.com',
  mobile: '+92 301 2345678',
  currency: 'PKR',
  branchCode: '0002',
  settlementAccount: 'ACC-10002',
  designation: 'Officer',
  status: 'valid'
}];
const MOCK_INVALID_RECORDS: RecordData[] = [{
  id: 3,
  fullName: 'Ali',
  username: 'ali.ahmed',
  email: 'invalid-email',
  mobile: '030012345',
  currency: 'PKR',
  branchCode: '0003',
  settlementAccount: 'ACC-10003',
  designation: 'Clerk',
  status: 'invalid',
  errorReason: 'Invalid email format, Mobile number must be 11 digits'
}];
const MOCK_DUPLICATE_RECORDS: RecordData[] = [{
  id: 4,
  fullName: 'John Doe',
  username: 'john.doe',
  email: 'john.doe@example.com',
  mobile: '+92 300 1111111',
  currency: 'PKR',
  branchCode: '0001',
  settlementAccount: 'ACC-10004',
  designation: 'Manager',
  status: 'duplicate',
  errorReason: 'Username already exists'
}];
const BulkUploadListsModal: React.FC<BulkUploadListsModalProps> = ({
  open,
  onClose,
  batch
}) => {
  const [activeTab, setActiveTab] = useState(0);
  const {
    showToast
  } = useToast();
  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };
  const handleGetCheckApproval = () => {
    // Store new records in localStorage for checker inbox
    const recordsForApproval = MOCK_NEW_RECORDS.map(record => ({
      ...record,
      batchId: batch.batchId,
      fileName: batch.fileName,
      submittedAt: new Date().toISOString(),
      approvalStatus: 'pending'
    }));
    // Add to checker inbox
    const existingCheckerRecords = JSON.parse(localStorage.getItem('checkerInboxRecords') || '[]');
    localStorage.setItem('checkerInboxRecords', JSON.stringify([...existingCheckerRecords, ...recordsForApproval]));
    // Also add to maker inbox so maker can track all records
    const existingMakerRecords = JSON.parse(localStorage.getItem('makerInboxRecords') || '[]');
    localStorage.setItem('makerInboxRecords', JSON.stringify([...existingMakerRecords, ...recordsForApproval]));
    showToast('Records sent to Checker Inbox for approval', 'success', 'Approval Requested');
    onClose();
  };
  const renderRecordTable = (records: RecordData[], showActions: boolean = false) => <TableContainer data-id="element-306" data-mp="1gp5elritq8ct">
      <Table size="medium" data-id="element-307" data-mp="1golsrzq1yzti">
        <TableHead data-id="element-308" data-mp="1cobpiutnanic">
          <TableRow data-id="element-309" data-mp="1cpwgkagr3obg">
            <TableCell sx={{
            fontWeight: 600
          }} data-id="element-310" data-mp="1cp3a7alpf0tu">
              Full Name
            </TableCell>
            <TableCell sx={{
            fontWeight: 600
          }} data-id="element-311" data-mp="12r73cuzsus1j">
              Username
            </TableCell>
            <TableCell sx={{
            fontWeight: 600
          }} data-id="element-312" data-mp="xtnmrofmq36f">
              Email
            </TableCell>
            <TableCell sx={{
            fontWeight: 600
          }} data-id="element-313" data-mp="32t6lepi4qdc5">
              Mobile
            </TableCell>
            <TableCell sx={{
            fontWeight: 600
          }} data-id="element-314" data-mp="2o1xvsge88rz0">
              Currency
            </TableCell>
            <TableCell sx={{
            fontWeight: 600
          }} data-id="element-315" data-mp="2f2avjxx8hs7j">
              Branch Code
            </TableCell>
            <TableCell sx={{
            fontWeight: 600
          }} data-id="element-316" data-mp="25567fsjtvmo3">
              Settlement Account
            </TableCell>
            <TableCell sx={{
            fontWeight: 600
          }} data-id="element-317" data-mp="2a4rgivsppbej">
              Designation
            </TableCell>
            <TableCell sx={{
            fontWeight: 600
          }} data-id="element-318" data-mp="8dedyde7vfln">
              Status
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody data-id="element-319" data-mp="1nw3zbywa33c7">
          {records.map(record => <TableRow key={record.id} hover data-id="element-320" data-mp="1nxnefm6778ce">
              <TableCell data-id="element-321" data-mp="22l8j3kiq1fmf">{record.fullName}</TableCell>
              <TableCell data-id="element-322" data-mp="22m1j82n6d6vl">{record.username}</TableCell>
              <TableCell data-id="element-323" data-mp="1xtqemmhhowwp">{record.email}</TableCell>
              <TableCell data-id="element-324" data-mp="1xrx8d8asgep8">{record.mobile}</TableCell>
              <TableCell data-id="element-325" data-mp="2bkn444g4cxzj">{record.currency}</TableCell>
              <TableCell data-id="element-326" data-mp="2bn9f6e27xvmi">
                <Chip label={record.branchCode} size="small" sx={{
              backgroundColor: 'rgba(6, 182, 212, 0.1)',
              color: '#06B6D4',
              fontWeight: 600
            }} data-id="element-327" data-mp="27kcos16fsv80" />
              </TableCell>
              <TableCell data-id="element-328" data-mp="r6mj4pzo5yw9">{record.settlementAccount}</TableCell>
              <TableCell data-id="element-329" data-mp="m6qf4qqz27gp">{record.designation}</TableCell>
              <TableCell data-id="element-330" data-mp="m81lmybsxtbi">
                {record.status === 'valid' && <Chip label="Valid" size="small" sx={{
              backgroundColor: 'rgba(16, 185, 129, 0.1)',
              color: '#10B981'
            }} data-id="element-331" data-mp="2m9rlvsj8qdri" />}
                {record.status === 'invalid' && <Chip label="Invalid" size="small" sx={{
              backgroundColor: 'rgba(239, 68, 68, 0.1)',
              color: '#EF4444'
            }} data-id="element-332" data-mp="306eitvb713xf" />}
                {record.status === 'duplicate' && <Chip label="Duplicate" size="small" sx={{
              backgroundColor: 'rgba(245, 158, 11, 0.1)',
              color: '#F59E0B'
            }} data-id="element-333" data-mp="3izifzqnmdyws" />}
              </TableCell>
            </TableRow>)}
          {records.length === 0 && <TableRow data-id="element-334" data-mp="1wmdi1ohcwj3">
              <TableCell colSpan={9} align="center" sx={{
            py: 3
          }} data-id="element-335" data-mp="1wcwh3lexzpj">
                No records found
              </TableCell>
            </TableRow>}
        </TableBody>
      </Table>
    </TableContainer>;
  return <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth PaperProps={{
    sx: {
      borderRadius: 2
    }
  }} data-id="element-336" data-mp="pkvw6uqed460">
      <DialogTitle sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      pb: 2
    }} data-id="element-337" data-mp="fvm0l4wch3d5">
        <Box data-id="element-338" data-mp="18cg8sna4x1xs">
          <Typography variant="h6" fontWeight={600} data-id="element-339" data-mp="18d87w82xxhst">
            Bulk Upload List
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{
          mt: 0.5
        }} data-id="element-340" data-mp="13lq3fa1pkz33">
            {batch.fileName} • {batch.dataRows} rows
          </Typography>
        </Box>
        <IconButton onClick={onClose} size="small" data-id="element-341" data-mp="1s21qli9zzo39">
          <Icon icon="lucide:x" width={20} height={20} data-id="element-342" data-mp="1dccif33hmjth" />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{
      p: 0
    }} data-id="element-343" data-mp="1iae47vsasx8n">
        <Box sx={{
        borderBottom: 1,
        borderColor: 'divider'
      }} data-id="element-344" data-mp="1i8kxyhllkf16">
          <Tabs value={activeTab} onChange={handleTabChange} sx={{
          px: 3
        }} data-id="element-345" data-mp="2azb8uw3l6vix">
            <Tab label={<Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }} data-id="element-347" data-mp="211584htinvfn">
                  <Typography variant="body2" fontWeight={500} data-id="element-348" data-mp="pm8ip6tf747r">
                    New Records
                  </Typography>
                  <Chip label={MOCK_NEW_RECORDS.length} size="small" sx={{
              height: 20,
              fontSize: '0.7rem',
              backgroundColor: 'rgba(16, 185, 129, 0.1)',
              color: '#10B981'
            }} data-id="element-349" data-mp="33t80j8y7brig" />
                </Box>} data-id="element-346" data-mp="1w22edtizlbmz" />
            <Tab label={<Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }} data-id="element-351" data-mp="2l1fb1oiccofh">
                  <Typography variant="body2" fontWeight={500} data-id="element-352" data-mp="2tx4sjmgo4ynl">
                    Invalid Records
                  </Typography>
                  <Chip label={MOCK_INVALID_RECORDS.length} size="small" sx={{
              height: 20,
              fontSize: '0.7rem',
              backgroundColor: 'rgba(239, 68, 68, 0.1)',
              color: '#EF4444'
            }} data-id="element-353" data-mp="21fajnnjeh1c1" />
                </Box>} data-id="element-350" data-mp="2l4kyz0f8hk9m" />
            <Tab label={<Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }} data-id="element-355" data-mp="3enl80i77vtb">
                  <Typography variant="body2" fontWeight={500} data-id="element-356" data-mp="3po6vtldv9d8f">
                    Duplicate Records
                  </Typography>
                  <Chip label={MOCK_DUPLICATE_RECORDS.length} size="small" sx={{
              height: 20,
              fontSize: '0.7rem',
              backgroundColor: 'rgba(245, 158, 11, 0.1)',
              color: '#F59E0B'
            }} data-id="element-357" data-mp="3kuvozk920wgi" />
                </Box>} data-id="element-354" data-mp="3fp7l14o04qc" />
          </Tabs>
        </Box>
        <Box sx={{
        p: 3
      }} data-id="element-358" data-mp="1hgl9y5rgnipy">
          {activeTab === 0 && renderRecordTable(MOCK_NEW_RECORDS, true)}
          {activeTab === 1 && renderRecordTable(MOCK_INVALID_RECORDS)}
          {activeTab === 2 && renderRecordTable(MOCK_DUPLICATE_RECORDS)}
        </Box>
      </DialogContent>
      <DialogActions sx={{
      p: 3,
      pt: 2
    }} data-id="element-359" data-mp="1vf1gnwpbp983">
        <Button variant="outlined" onClick={onClose} data-id="element-360" data-mp="yqdg6e9ni4mf">
          Close
        </Button>
        {activeTab === 0 && <Button variant="contained" onClick={handleGetCheckApproval} data-id="element-361" data-mp="13ox2wgw2jkfu">
            Get Check Approval
          </Button>}
      </DialogActions>
    </Dialog>;
};
export default BulkUploadListsModal;